import SmoothScroll from 'smooth-scroll';

new SmoothScroll('[data-scroll]', {
    header: '[data-scroll-header]',
    speed: 600,
});
